// Languages
import en from "./en/index.json";

export default {
  en,
};
